var _excluded = ["className"],
  _excluded2 = ["className"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRTL } from "../../../hooks/useRTL";
import { cn } from "../../../lib/utils";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cva } from 'class-variance-authority';
import React, { useEffect, useRef, useState } from 'react';
import * as styles from "../../style/tabs";
import SliderBtnIcon, { ExtraContent } from "./SliderBtnIcon";
import { BUTTON_BG_TYPE_ITEM_BOX_CLASS, getGutterDefaultSize, SLIDE_ICON_WIDTH, TAB_TITLE_BOX_CLASS } from "./tabs.constant";
import { renderTabItem } from "./tabs.fun";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var buttonVariants = cva('', {
  variants: {
    size: {
      huge: 'text-xl h-14',
      large: 'text-lg h-12',
      medium: 'text-base h-10',
      small: 'text-sm h-8',
      mini: 'text-xs h-6',
      xl: 'text-xl h-14',
      l: 'text-lg h-12',
      m: 'text-base h-10',
      s: 'text-sm h-8',
      xs: 'text-xs h-6'
    },
    tabType: {
      title: '',
      buttonBg: 'color-base-bds-gray-t1',
      button: 'color-base-bds-gray-t2 bg-base-bds-gray-ele-edge',
      text: ''
    }
  },
  defaultVariants: {
    size: 'large',
    tabType: 'title'
  }
});

// Tab props

var RadixTabRoot = TabsPrimitive.Root;
var TabsList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(TabsPrimitive.List, _objectSpread({
    ref: ref
  }, props));
});
TabsList.displayName = TabsPrimitive.List.displayName;
var TabsTrigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(TabsPrimitive.Trigger, _objectSpread({
    ref: ref,
    className: cn(className)
  }, props));
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
var TabsContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(TabsPrimitive.Content, _objectSpread({
    ref: ref,
    className: cn(className)
  }, props));
});
TabsContent.displayName = TabsPrimitive.Content.displayName;
var Tabs = function Tabs(props) {
  var _ref4;
  var _ref3 = props !== null && props !== void 0 ? props : {},
    className = _ref3.className,
    tabTitleClassName = _ref3.tabTitleClassName,
    activeKey = _ref3.activeKey,
    defaultActiveKey = _ref3.defaultActiveKey,
    _ref3$items = _ref3.items,
    items = _ref3$items === void 0 ? [] : _ref3$items,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'large' : _ref3$size,
    tabBarExtraContent = _ref3.tabBarExtraContent,
    tabBarGutter = _ref3.tabBarGutter,
    tabBarWithContentGutter = _ref3.tabBarWithContentGutter,
    _ref3$tabType = _ref3.tabType,
    tabType = _ref3$tabType === void 0 ? 'title' : _ref3$tabType,
    onChange = _ref3.onChange,
    _ref3$buttonType = _ref3.buttonType,
    buttonType = _ref3$buttonType === void 0 ? 'default' : _ref3$buttonType,
    showScrollButton = _ref3.showScrollButton,
    _ref3$isEqualDivided = _ref3.isEqualDivided,
    isEqualDivided = _ref3$isEqualDivided === void 0 ? false : _ref3$isEqualDivided,
    _ref3$isMobile = _ref3.isMobile,
    isMobile = _ref3$isMobile === void 0 ? false : _ref3$isMobile;
  var scrollRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    arrowShow = _useState2[0],
    setArrowShow = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    leftArrowShow = _useState4[0],
    setLeftArrowShow = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    rightArrowShow = _useState6[0],
    setRightArrowShow = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isItemTransActive = _useState8[0],
    setIsItemTransActive = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    showBottomAfterLine = _useState10[0],
    setShowBottomAfterLine = _useState10[1];
  var _useState11 = useState({
      width: 0,
      left: 0
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    tabActiveBar = _useState12[0],
    setTabActiveBar = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    currentActiveKey = _useState14[0],
    setCurrentActiveKey = _useState14[1];
  var isRTL = useRTL();
  var defaultTabBarGutterClass = getGutterDefaultSize({
    tabType: tabType,
    isRTL: isRTL,
    size: size
  });
  var tabTitleMargin = tabBarGutter !== undefined ? isRTL ? {
    marginRight: "".concat(tabBarGutter, "px")
  } : {
    marginLeft: "".concat(tabBarGutter, "px")
  } : {};
  useEffect(function () {
    var _scrollRef$current, _scrollRef$current2;
    var sWidth = ((_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollWidth) || 0;
    var cWidth = ((_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.clientWidth) || 0;
    setArrowShow(sWidth !== cWidth);
  }, [items]);
  var onArrowClickPrev = function onArrowClickPrev() {
    var _scrollRef$current3, _scrollRef$current4, _scrollRef$current5;
    var showArrowCount = [leftArrowShow, rightArrowShow].filter(function (item) {
      return item;
    }).length;
    var sLeft = ((_scrollRef$current3 = scrollRef.current) === null || _scrollRef$current3 === void 0 ? void 0 : _scrollRef$current3.scrollLeft) || 0;
    var cWidth = ((_scrollRef$current4 = scrollRef.current) === null || _scrollRef$current4 === void 0 ? void 0 : _scrollRef$current4.clientWidth) || 0;
    var nextPrev = isRTL ? Math.min(sLeft + (cWidth + showArrowCount * SLIDE_ICON_WIDTH) / 2, 0) : Math.max(sLeft - (cWidth + showArrowCount * SLIDE_ICON_WIDTH) / 2, 0);
    (_scrollRef$current5 = scrollRef.current) === null || _scrollRef$current5 === void 0 || _scrollRef$current5.scrollTo({
      left: nextPrev,
      behavior: 'smooth'
    });
  };
  var onArrowClickNext = function onArrowClickNext() {
    var _scrollRef$current6, _scrollRef$current7, _scrollRef$current8, _scrollRef$current9;
    var showArrowCount = [leftArrowShow, rightArrowShow].filter(function (item) {
      return item;
    }).length;
    var sLeft = ((_scrollRef$current6 = scrollRef.current) === null || _scrollRef$current6 === void 0 ? void 0 : _scrollRef$current6.scrollLeft) || 0;
    var sWidth = ((_scrollRef$current7 = scrollRef.current) === null || _scrollRef$current7 === void 0 ? void 0 : _scrollRef$current7.scrollWidth) || 0;
    var cWidth = ((_scrollRef$current8 = scrollRef.current) === null || _scrollRef$current8 === void 0 ? void 0 : _scrollRef$current8.clientWidth) || 0;
    var nextNext = isRTL ? Math.min(sLeft - (cWidth + showArrowCount * SLIDE_ICON_WIDTH) / 2, sWidth) : Math.min(sLeft + (cWidth + showArrowCount * SLIDE_ICON_WIDTH) / 2, sWidth);
    (_scrollRef$current9 = scrollRef.current) === null || _scrollRef$current9 === void 0 || _scrollRef$current9.scrollTo({
      left: nextNext,
      behavior: 'smooth'
    });
  };
  var onScrollCapture = function onScrollCapture() {
    if (showScrollButton) {
      var _scrollRef$current10, _scrollRef$current11, _scrollRef$current12;
      var sLeft = Math.abs(((_scrollRef$current10 = scrollRef.current) === null || _scrollRef$current10 === void 0 ? void 0 : _scrollRef$current10.scrollLeft) || 0);
      var sWidth = ((_scrollRef$current11 = scrollRef.current) === null || _scrollRef$current11 === void 0 ? void 0 : _scrollRef$current11.scrollWidth) || 0;
      var cWidth = ((_scrollRef$current12 = scrollRef.current) === null || _scrollRef$current12 === void 0 ? void 0 : _scrollRef$current12.clientWidth) || 0;
      var totalScrollWidth = sWidth - cWidth;
      setLeftArrowShow(sLeft >= 10);
      setRightArrowShow(totalScrollWidth - sLeft >= 10);
    }
  };
  useEffect(function () {
    onScrollCapture();
  }, [showScrollButton]);
  var currentKey = (_ref4 = activeKey !== null && activeKey !== void 0 ? activeKey : currentActiveKey) !== null && _ref4 !== void 0 ? _ref4 : defaultActiveKey;
  var setBottomActiveLinePosition = function setBottomActiveLinePosition() {
    var _scrollRef$current13;
    var activeIndex = items.findIndex(function (item) {
      return item.key === currentKey;
    });
    var activeDomClient = (_scrollRef$current13 = scrollRef.current) === null || _scrollRef$current13 === void 0 ? void 0 : _scrollRef$current13.children[activeIndex];
    var _ref5 = activeDomClient !== null && activeDomClient !== void 0 ? activeDomClient : {},
      _ref5$clientWidth = _ref5.clientWidth,
      clientWidth = _ref5$clientWidth === void 0 ? 0 : _ref5$clientWidth,
      _ref5$offsetLeft = _ref5.offsetLeft,
      offsetLeft = _ref5$offsetLeft === void 0 ? 0 : _ref5$offsetLeft;
    setShowBottomAfterLine(clientWidth === 0);
    setTabActiveBar({
      width: clientWidth,
      left: offsetLeft
    });
  };
  useEffect(function () {
    if (tabType === 'title') {
      setBottomActiveLinePosition();
    }
  }, [currentKey, isRTL, items, tabType]);
  useEffect(function () {
    var _scrollRef$current14, _scrollDom$clientWidt, _scrollDom$scrollLeft;
    // 如果当前activetab不在视野内，自动滚动到视野内
    var activeIndex = items.findIndex(function (item) {
      return item.key === currentKey;
    });
    var scrollDom = scrollRef.current;
    var activeDomClient = (_scrollRef$current14 = scrollRef.current) === null || _scrollRef$current14 === void 0 ? void 0 : _scrollRef$current14.children[activeIndex];
    var totalWidth = (_scrollDom$clientWidt = scrollDom === null || scrollDom === void 0 ? void 0 : scrollDom.clientWidth) !== null && _scrollDom$clientWidt !== void 0 ? _scrollDom$clientWidt : 0;
    var scrollLeft = (_scrollDom$scrollLeft = scrollDom === null || scrollDom === void 0 ? void 0 : scrollDom.scrollLeft) !== null && _scrollDom$scrollLeft !== void 0 ? _scrollDom$scrollLeft : 0;
    var _ref6 = activeDomClient !== null && activeDomClient !== void 0 ? activeDomClient : {},
      _ref6$clientWidth = _ref6.clientWidth,
      clientWidth = _ref6$clientWidth === void 0 ? 0 : _ref6$clientWidth,
      _ref6$offsetLeft = _ref6.offsetLeft,
      offsetLeft = _ref6$offsetLeft === void 0 ? 0 : _ref6$offsetLeft;
    var cRight = totalWidth - (offsetLeft - scrollLeft) - clientWidth;
    var cLeft = offsetLeft - scrollLeft;
    if (cLeft < 0) {
      scrollDom === null || scrollDom === void 0 || scrollDom.scrollTo({
        left: offsetLeft - 2,
        behavior: 'smooth'
      });
    }
    if (cRight < 0) {
      scrollDom === null || scrollDom === void 0 || scrollDom.scrollTo({
        left: offsetLeft - totalWidth + clientWidth + 2,
        behavior: 'smooth'
      });
    }
  }, [currentKey]);
  useEffect(function () {
    if (tabType === 'title') {
      setIsItemTransActive(false);
      setBottomActiveLinePosition();
      setIsItemTransActive(true);
    }
  }, [size, isEqualDivided]);
  var onTabChange = function onTabChange(value) {
    setCurrentActiveKey(value);
    if (onChange) {
      onChange(value);
    }
  };
  return /*#__PURE__*/_jsxs(RadixTabRoot, {
    className: cn('moly-tabs', className),
    value: activeKey,
    defaultValue: defaultActiveKey,
    onValueChange: onTabChange,
    dir: isRTL ? 'rtl' : 'ltr',
    children: [/*#__PURE__*/_jsxs(TabsList, {
      className: cn('flex items-center text-base-bds-gray-t2 font-semibold relative', {
        'border-b border-base-bds-gray-ele-line border-solid': tabType === 'title'
      }, tabTitleClassName, TAB_TITLE_BOX_CLASS[size]),
      children: [/*#__PURE__*/_jsx(ExtraContent, {
        position: "left",
        extra: tabBarExtraContent
      }), showScrollButton && arrowShow && leftArrowShow ? /*#__PURE__*/_jsx(SliderBtnIcon, {
        className: "bg-base-bds-gray-bg-card hover:bg-base-bds-gray-ele-edge text-base-bds-gray-t2 rounded-sm",
        direction: isRTL ? 'right' : 'left',
        handleClick: onArrowClickPrev
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: cn(styles.tabTitleScrollBar, 'items-center flex overflow-x-auto scroll-smooth relative', _defineProperty(_defineProperty({
          'flex-1': isEqualDivided,
          'bg-base-bds-gray-ele-line': tabType === 'buttonBg'
        }, "".concat(BUTTON_BG_TYPE_ITEM_BOX_CLASS[size]), tabType === 'buttonBg'), "".concat(buttonVariants({
          size: size,
          tabType: tabType
        })), tabType === 'buttonBg')),
        ref: scrollRef,
        onScrollCapture: onScrollCapture,
        children: [items.map(function (item, index) {
          var _ref7 = item !== null && item !== void 0 ? item : {},
            key = _ref7.key,
            disabled = _ref7.disabled,
            label = _ref7.label;
          return /*#__PURE__*/_jsx(TabsTrigger, {
            value: key,
            disabled: disabled,
            asChild: true,
            children: renderTabItem({
              label: label,
              tabType: tabType,
              buttonType: buttonType,
              size: size,
              tabClass: index === 0 ? undefined : defaultTabBarGutterClass,
              tabStyle: index === 0 ? undefined : tabTitleMargin,
              isEqualDivided: isEqualDivided,
              singleLineClass: styles.singleLine,
              showActiveBottomLine: currentKey === key && showBottomAfterLine,
              buttonVariants: buttonVariants,
              isMobile: isMobile
            })
          }, "tab-lis-".concat(key));
        }), tabType === 'title' ? /*#__PURE__*/_jsx("div", {
          style: tabActiveBar,
          className: cn('absolute bottom-0 bg-brandColor-bds-brand-700-normal h-0.5', {
            'transition-all': isItemTransActive
          })
        }) : null]
      }), showScrollButton && arrowShow && rightArrowShow ? /*#__PURE__*/_jsx(SliderBtnIcon, {
        className: "bg-base-bds-gray-bg-card hover:bg-base-bds-trans-hover text-base-bds-gray-t2 rounded-sm",
        direction: isRTL ? 'left' : 'right',
        handleClick: onArrowClickNext
      }) : null, tabBarExtraContent ? /*#__PURE__*/_jsx("div", {
        className: "flex-1"
      }) : null, /*#__PURE__*/_jsx(ExtraContent, {
        position: "right",
        extra: tabBarExtraContent
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "moly-tabs-content",
      style: tabBarWithContentGutter ? {
        marginTop: "".concat(tabBarWithContentGutter, "px")
      } : {},
      children: items.map(function (item) {
        var _ref8 = item !== null && item !== void 0 ? item : {},
          key = _ref8.key,
          children = _ref8.children;
        return /*#__PURE__*/_jsx(TabsContent, {
          value: key,
          children: children
        }, "tab-cont-".concat(key));
      })
    })]
  });
};
export { Tabs };